import {ValidatorTestResult} from '../entity-validator.types';

export namespace CycleTriggerValidator {
	// TODO: Check if relevant
	export function validateTriggers(triggers: any[]): ValidatorTestResult {
		const result: ValidatorTestResult = {valid: true, errors: []};

		return result;
	}
}
